import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { DialogComponent } from './dialog.component';
import { MaterialComponentsModule } from '../material-components.module';
@NgModule({
  declarations: [DialogComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    MaterialComponentsModule
  ],
  exports: [
    DialogComponent
  ],
  entryComponents: [DialogComponent],
})
export class DialogModule { }
